import axios from 'axios';
import store from '@/store';

// Set config defaults when creating the instance
const axiosObject = axios.create();

axiosObject.interceptors.request.use(
  async function (config) {
    const key = store.getters['account/activeConcept'] ? store.getters['account/activeConcept'].key : '';
    const token = store.getters['account/getUser'].attributes.token; // Get your access token here.
    const lang = store.getters['app/getLocale'].replace('_', '-').toLowerCase();
    config.headers.Authorization = `Bearer ${token}`;
    config.headers['Solo-Concept'] = key;
    config.headers['Accept-Language'] = lang;
    return config;
  },
  function (error) {
    // Do something with request error
    console.error('error: interceptors', error);
    return Promise.reject(error);
  },
);

// Add a response interceptor
axiosObject.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  },
);

export default axiosObject;
